import React from "react";

export default function SectorsSection() {
  return (
    <section className="px-4 md:px-[199px] py-8 md:py-[40px]">
      <div className="text-center mb-8 md:mb-[44px]">
        <h2 className="font-bauhaus font-bold text-2xl md:text-[42px] leading-tight md:leading-[46px] text-[#002342] mb-[20px]">
          Setores que conectamos com Impacto
        </h2>
      </div>
      <div className="w-full">
        <img
          src="/assets/landing-2025/sectors-image.png"
          alt="Setores que conectamos com impacto"
          className="w-full h-auto rounded-lg"
        />
      </div>
    </section>
  );
}
